import React, { useState } from 'react';
import './PhoneModal.css';

const PhoneModal = ({ user, onSubmit, onCancel, loading }) => {
  const [telefono, setTelefono] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Validar teléfono
    if (!telefono.trim()) {
      setError('El teléfono es obligatorio.');
      return;
    }

    // Validar formato básico (al menos 10 dígitos, permite símbolos internacionales)
    const cleanedPhone = telefono.replace(/[\s\-()]/g, '');
    const phoneRegex = /^\+?[0-9]{10,}$/;
    if (!phoneRegex.test(cleanedPhone)) {
      setError('Por favor ingresa un teléfono válido (al menos 10 dígitos).');
      return;
    }

    onSubmit(telefono);
  };

  return (
    <div className="phone-modal-overlay">
      <div className="phone-modal">
        <h2>Completar tu Perfil</h2>
        <p className="subtitle">
          Necesitamos tu número de teléfono para completar tu registro
        </p>

        <div className="user-info">
          {user.photoURL && (
            <img src={user.photoURL} alt="Usuario" className="user-avatar" />
          )}
          <div>
            <p className="user-name">
              {user.name} {user.apellido}
            </p>
            <p className="user-email">{user.email}</p>
          </div>
        </div>

        {error && <p className="error-message">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="telefono">Número de Teléfono *</label>
            <input
              type="tel"
              id="telefono"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              placeholder="+54 9 11 1234-5678"
              disabled={loading}
              required
            />
            <small>Incluye el código de país (ej: +54 para Argentina)</small>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onCancel}
              className="cancel-button"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Guardando...' : 'Completar Registro'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PhoneModal;
